import type { FormControl } from '@angular/forms';

/**
 * Перечисление всех возможных чекбоксов для формы жалобы
 */
export enum EComplainCheckbox {
  THREATS = 'threats',
  CRUELTY = 'cruelty',
  FALSE = 'false',
  HATRED = 'hatred',
  NSFW = 'nsfw',
  HARASSMENT = 'harassment',
  CHILD_EXPLOIT = 'child_exploit',
  SELF_HARM = 'self_harm',
  TERRORISM = 'terrorism',
  ILLEGAL = 'illegal',
  DRUGS = 'drugs',
  CONFIDENTIALITY = 'confidentiality',
  IMPERSONATION = 'impersonation',
  SPAM = 'spam',
}

/**
 * Соответствие между enum и текстовыми метками для отображения
 * Использует отдельные строки для возможности локализации
 */
export const COMPLAIN_CHECKBOX_LABELS: Readonly<Record<EComplainCheckbox, string>> = {
  [EComplainCheckbox.THREATS]: 'MODALS.COMPLAIN.CHECKBOX.THREATS',
  [EComplainCheckbox.CRUELTY]: 'MODALS.COMPLAIN.CHECKBOX.CRUELTY',
  [EComplainCheckbox.FALSE]: 'MODALS.COMPLAIN.CHECKBOX.FALSE',
  [EComplainCheckbox.HATRED]: 'MODALS.COMPLAIN.CHECKBOX.HATRED',
  [EComplainCheckbox.NSFW]: 'MODALS.COMPLAIN.CHECKBOX.NSFW',
  [EComplainCheckbox.HARASSMENT]: 'MODALS.COMPLAIN.CHECKBOX.HARASSMENT',
  [EComplainCheckbox.CHILD_EXPLOIT]: 'MODALS.COMPLAIN.CHECKBOX.CHILD_EXPLOIT',
  [EComplainCheckbox.SELF_HARM]: 'MODALS.COMPLAIN.CHECKBOX.SELF_HARM',
  [EComplainCheckbox.TERRORISM]: 'MODALS.COMPLAIN.CHECKBOX.TERRORISM',
  [EComplainCheckbox.ILLEGAL]: 'MODALS.COMPLAIN.CHECKBOX.ILLEGAL',
  [EComplainCheckbox.DRUGS]: 'MODALS.COMPLAIN.CHECKBOX.DRUGS',
  [EComplainCheckbox.CONFIDENTIALITY]: 'MODALS.COMPLAIN.CHECKBOX.CONFIDENTIALITY',
  [EComplainCheckbox.IMPERSONATION]: 'MODALS.COMPLAIN.CHECKBOX.IMPERSONATION',
  [EComplainCheckbox.SPAM]: 'MODALS.COMPLAIN.CHECKBOX.SPAM',
} as const;

/**
 * Тип для элемента чекбокса (используется в компоненте)
 */
export interface CheckboxItem {
  readonly id: EComplainCheckbox;
  readonly label: string;
}

/**
 * Интерфейс формы жалобы
 */
export interface IComplainForm {
  // Чекбоксы для оценки контента
  [EComplainCheckbox.THREATS]: FormControl<boolean>;
  [EComplainCheckbox.CRUELTY]: FormControl<boolean>;
  [EComplainCheckbox.FALSE]: FormControl<boolean>;
  [EComplainCheckbox.HATRED]: FormControl<boolean>;
  [EComplainCheckbox.NSFW]: FormControl<boolean>;
  [EComplainCheckbox.HARASSMENT]: FormControl<boolean>;
  [EComplainCheckbox.CHILD_EXPLOIT]: FormControl<boolean>;
  [EComplainCheckbox.SELF_HARM]: FormControl<boolean>;
  [EComplainCheckbox.TERRORISM]: FormControl<boolean>;
  [EComplainCheckbox.ILLEGAL]: FormControl<boolean>;
  [EComplainCheckbox.DRUGS]: FormControl<boolean>;
  [EComplainCheckbox.CONFIDENTIALITY]: FormControl<boolean>;
  [EComplainCheckbox.IMPERSONATION]: FormControl<boolean>;
  [EComplainCheckbox.SPAM]: FormControl<boolean>;

  // Текстовое поле для дополнительных деталей
  details: FormControl<string>;
}

/**
 * Тип для преобразования FormControl в их значения
 */
export type TFormValue<T> = {
  [K in keyof T]: T[K] extends FormControl<infer U> ? U : never;
};

/**
 * Максимальное количество выбранных чекбоксов
 */
export const MAX_SELECTED_CHECKBOXES = 5;

/**
 * Тип для результата формы жалобы
 */
export interface IComplaintResult {
  /** Выбранные чекбоксы */
  reason?: EComplainCheckbox[];
  complaintReason?: EComplainCheckbox[];
  /** Дополнительные детали */
  details?: string | null;
  complaintDetails?: string | null;
}

/**
 * Интерфейс для тела запроса жалобы
 * */
export interface IReportBody {
  id: string;
  report: IComplaintResult;
}
